<script setup>
import axios from 'axios'
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const route = useRoute()
const logList = ref([])
const contentList = ref([])
const config = useRuntimeConfig()
// ローカルストレージに保存する関数
const saveArrayToLocalStorage = (key, array) => {
  localStorage.setItem(key, JSON.stringify(array))
}
// ローカルストレージから読み出す関数
const getArrayFromLocalStorage = (key) => {
  const data = localStorage.getItem(key)
  return data ? JSON.parse(data) : []
}
onBeforeMount(async () => {
  if (import.meta.client) {
    logList.value = getArrayFromLocalStorage('livecam_history')
    const results = await Promise.all(
      logList.value.map((item) => {
        return axios.get(`${config.app.baseURL}api/livecam/thumbnaildata?id=${item.id}`)
      })
    )
    contentList.value = results.filter((result) => result.data !== null).filter((result) => result.status === 200).map((result) => result.data)
  }
})

onMounted(() => {
  if (route.params.id) {
    let newLogList = [...logList.value]
    newLogList = newLogList.filter((item) => item.id !== route.params.id)
    newLogList = newLogList.slice(0, 2)
    newLogList.unshift({ id: route.params.id })
    saveArrayToLocalStorage('livecam_history', newLogList)
    logList.value = newLogList
  }
})
</script>

<template>
  <section class="livecamRowList">
    <SectionTitle title="閲覧履歴" />
    <ClientOnly>
      <ul
        v-if="contentList.length!==0"
        class="content"
      >
        <li
          v-for="(content, index) in contentList"
          :key="index"
        >
          <LivecamBlock
            :text="content.text"
            :link="content.link"
            :date="content.latest"
            :img="content.image"
          />
        </li>
      </ul>
      <div
        v-if="contentList.length===0"
        class="content"
      >
        <p>閲覧履歴はありません。</p>
      </div>
    </ClientOnly>
  </section>
</template>

<style scoped>
.livecamRowList {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .content {
    display: flex;
    gap: 6px;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 8px;
      background-color: #fff;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 8px;
      background: #438fec;
    }
    li {
      width: calc((100% - 12px) / 3);
      min-width: 153px;
    }
  }
}
</style>
